export const releasesHref = (path: string): string => {
  const root = path.startsWith("http")
    ? ""
    : "https://mondoo.com/docs/releases";
  return `${root}${path}`;
};
